// Import helpers
import { ALL_OPERATORS, CONFIGURATOR_OPERATORS, RECORDINGS_OPERATORS } from 'helpers/operators';

// Import routes
import { CONFIGURATOR_PATHS } from 'components/routes/configurator/routes';

export const NAV_LINKS = [
	{
		slug: 'Start',
		name: 'start',
		id: 'start',
		path: '/tv/strona-glowna',
		translationSection: 'header_nav',
		operators: ALL_OPERATORS
	},
	{
		slug: 'Telewizja',
		name: 'tv',
		id: 'tv',
		path: '/tv/telewizja',
		translationSection: 'header_nav',
		operators: ALL_OPERATORS
	},
	{
		slug: 'Program TV',
		name: 'epg',
		id: 'epg',
		path: '/tv/epg',
		translationSection: 'header_nav',
		operators: ALL_OPERATORS
	},
	{
		slug: 'VOD',
		name: 'vod',
		id: 'vod',
		path: '/vod/filmy',
		translationSection: 'header_nav',
		operators: ALL_OPERATORS
	},
	{
		slug: 'KIDS',
		name: 'kids',
		id: 'kids',
		path: '/vod/dla-dzieci',
		translationSection: 'header_nav',
		operators: ALL_OPERATORS
	},
	{
		slug: '',
		name: 'recordings',
		id: 'recordings',
		path: '/tv/nagrania',
		translationSection: 'header_nav',
		operators: RECORDINGS_OPERATORS
	},
	{
		slug: '',
		name: 'offer',
		id: 'offer',
		path: CONFIGURATOR_PATHS.OFFER,
		translationSection: 'header_nav',
		operators: CONFIGURATOR_OPERATORS
	},
	{
		slug: 'Konfigurator',
		name: 'configurator',
		id: 'configurator',
		path: CONFIGURATOR_PATHS.OFFER_REVIEW,
		translationSection: 'header_nav',
		itemModifiers: 'distinctive',
		navLinkModifiers: 'distinctive',
		operators: CONFIGURATOR_OPERATORS
	}
];
